import React from 'react';

import FullPageModalIFramaContent from 'src/presentation/components/pages/glados/components/FullPageModalIFramaContent';

const ActionAdapterRunsLog = ({ id, root }) => {
  return <FullPageModalIFramaContent root={root} srcPath={`/${id}/runs`} />;
};

export default ActionAdapterRunsLog;
